import React from 'react';
import { SkeletonItem } from '@atlaskit/menu';
import { ModalHeader, ModalTitle, ModalBody, ModalFooter } from '@atlaskit/modal-dialog';
import { Stack } from '@atlaskit/primitives';
import { JiraModal as Modal } from '@atlassian/jira-modal/src/ui/jira-modal.tsx';

type ModalSkeletonProps = {
	title?: string;
	onClose?: () => void;
};

export const ModalSkeleton = ({ onClose, title }: ModalSkeletonProps) => (
	<Modal
		onClose={onClose}
		width={968}
		height={576}
		messageId="end-of-trial-message-shared-global-component.ui.modal.jira-modal"
		messageType="engagement"
	>
		<ModalHeader>
			{title ? (
				<ModalTitle>{title}</ModalTitle>
			) : (
				<Stack grow="fill">
					<SkeletonItem />
				</Stack>
			)}
		</ModalHeader>
		<ModalBody>
			<SkeletonItem />
			<SkeletonItem />
			<SkeletonItem />
		</ModalBody>
		<ModalFooter />
	</Modal>
);
